import { Box, Grid, ListItemText, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { ListAction, ListActions, StyledListItem, StyledListWrapper, StyledPagination } from "@framework/styled";
import { ILotteryToken } from "@framework/types";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";

import { LotteryRewardButton } from "../../../../../components/buttons";
import { decodeNumbers, decodeNumbersToArr, getWinners } from "./utils";
import { LotteryTokenSearchForm } from "./search";
import { LotteryTokenDialogView } from "./view";

const LOTTERY_TICKETS_TOKEN_URL = "/lottery/ticket/tokens";
const LOTTERY_TICKETS_TOKEN_DIALOG_KEY = "lotteryTicketTokens";

export const LotteryTicketTokenList = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<ILotteryToken>
  >(LOTTERY_TICKETS_TOKEN_URL, { enableInfiniteScroll: isMd });

  const { viewItem, handleView, viewDialogUniqueKey, closeViewDialog, viewMode } = useDialogView<ILotteryToken>();

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "lottery", "lottery.tokens"]} />

      <PageHeader message="pages.lottery.tokens.title" />

      <LotteryTokenSearchForm />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(token => (
            <StyledListItem key={token.id}>
              <ListItemText sx={{ flex: 1 }}>{token.round?.contract?.title}</ListItemText>
              <Box
                sx={theme => ({
                  [theme.breakpoints.down("md")]: {
                    display: "none",
                  },
                })}
              >
                <ListItemText sx={{ flex: 0.6 }}>{token.id}</ListItemText>
                <ListItemText sx={{ flex: 1 }}>{decodeNumbers(token.metadata.NUMBERS)}</ListItemText>
              </Box>
              <ListItemText sx={{ flex: 0.6 }}>
                {"Round #"}
                {token.round.roundId}
              </ListItemText>
              <Box
                sx={theme => ({
                  [theme.breakpoints.down("md")]: {
                    display: "none",
                  },
                })}
              >
                <ListItemText sx={{ flex: 1 }}>
                  {getWinners(decodeNumbersToArr(token.metadata.NUMBERS), token.round.numbers || [])}
                </ListItemText>
              </Box>
              <ListActions>
                <LotteryRewardButton token={token} />
                <ListAction
                  onClick={handleView(LOTTERY_TICKETS_TOKEN_DIALOG_KEY, token, "view")}
                  message="form.tips.view"
                  icon={Visibility}
                />
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      <LotteryTokenDialogView
        onCancel={closeViewDialog}
        onConfirm={closeViewDialog}
        open={viewDialogUniqueKey === `${LOTTERY_TICKETS_TOKEN_DIALOG_KEY}.${viewMode}`}
        viewItem={viewItem}
      />
    </Grid>
  );
};
